import React from 'react';
import PropTypes from 'prop-types';
import styles from './simple-layout.scss';

const FullHeightLayout = ({ children }) => (
  <div className={styles.container}>{children}</div>
);

FullHeightLayout.propTypes = {
  children: PropTypes.node,
};

export default FullHeightLayout;
